;
/*!
 * subitotexto.fontsizeswitcher.js
 */
SubitoTexto.fontSizeSwitcher = {

	init      : function () {
		var $ = jqPla,
			_this = SubitoTexto.fontSizeSwitcher;

		_this.$html = $( 'html' );
		_this.$body = _this.$html.find( 'body' );

		_this.$switcherContainer = _this.$body.find( '.font-size-switcher' );
		_this.$switchesButtons = _this.$switcherContainer.find( 'button' );

		_this.baseFontSize = 26;
		_this.currentSizeRatio = 1;

		_this.animationDuration = 500;

		if ( _this.$switcherContainer.length > 0 ) {
			_this.prepClasses();
			_this.getCookie();
			_this.setCookie();
			_this.setLiActive();
			_this.bindEvents();
		}

	},
	bindEvents: function () {
		var $ = jqPla,
			_this = SubitoTexto.fontSizeSwitcher;

		_this.$switcherContainer.on( 'click', 'button', function ( e ) {

			var $this = $( this ),
				buttonVal = $this.val();

			// No use in doing anything if they've click on the active one.
			if ( buttonVal == _this.currentSizeRatio ) {
				return;
			}

			_this.currentSizeRatio = $( this ).val();

			if ( _this.previousRatio != _this.currentSizeRatio ) {


				_this.setLiActive();
				_this.adjustSize();

			}
		} );
	},

	// Caching the available sizes so we can also add them to the body
	prepClasses: function () {
		var $ = jqPla,
			_this = SubitoTexto.fontSizeSwitcher;

		_this.arrFontSizeClasses = [];

		_this.$switchesButtons.each( function ( i, el ) {
			var $this = $( this ),
				bodyClass = $this.data( 'body-class' );

			if ( bodyClass ) {
				_this.arrFontSizeClasses.push( bodyClass );
			}
		} );

	},
	getCookie  : function () {
		var $ = jqPla,
			_this = SubitoTexto.fontSizeSwitcher;

		var cookieValue = Cookies.get( 'subito-texto-font-ratio' );


		if ( cookieValue ) {
			_this.currentSizeRatio = cookieValue;
			_this.adjustSize( true );
		}
	},
	setCookie  : function () {
		var $ = jqPla,
			_this = SubitoTexto.fontSizeSwitcher;

		Cookies.set( 'subito-texto-font-ratio', _this.currentSizeRatio, { expires: 365 } );

	},
	adjustSize : function ( noAnimation ) {
		var $ = jqPla,
			_this = SubitoTexto.fontSizeSwitcher;

		if ( noAnimation ) {
			_this.$html.css( {
				fontSize: _this.baseFontSize * _this.currentSizeRatio
			} );
			_this.setCookie();

		} else {

			_this.$html.animate( {
					fontSize: _this.baseFontSize * _this.currentSizeRatio
				},
				_this.animationDuration,
				function () {
					_this.setCookie();
				} );
		}
	},
	setLiActive: function () {
		var $ = jqPla,
			_this = SubitoTexto.fontSizeSwitcher;

		var $currentButton = _this.$switchesButtons.filter( '[value="' + _this.currentSizeRatio + '"]' ),
			bodyClass = $currentButton.data( 'body-class' );

		_this.$switchesButtons.not( $currentButton )
			.removeClass( 'active' )
			.attr( 'aria-pressed', false );

		$currentButton
			.addClass( 'active' )
			.attr( 'aria-pressed', true );


		_this.$body.removeClass( _this.arrFontSizeClasses.join( ' ' ) );
		_this.$body.addClass( bodyClass );


	}
};
